// extracted by mini-css-extract-plugin
export default {"title":"ToggleDisplay_title__jyoZC","inactive":"ToggleDisplay_inactive__wTB1M","active":"ToggleDisplay_active__IOb+s","content":"ToggleDisplay_content__csGvm"};